export default __webpack_public_path__ + "static/media/CNo.76-5.069a300e.jpg";